import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { Box, Button } from '@mui/material';
import { userBranchesAtom } from '../../../Atoms';
import { ColumnFlexBox } from '../../../Components/FlexBox';
import DateRangeField from '../../../Components/Inputs/DateRangeField';
import MultipleChipSelect from '../../../Components/Inputs/MultipleChipSelect';

const CampaignsFilters = function CampaignsFilters({
  defaultValue = {},
  onConfirm = () => {},
  onClose = () => {},
}) {
  const intl = useIntl();
  const userBranches = useAtomValue(userBranchesAtom);

  const [period, setPeriod] = useState(
    defaultValue?.scheduledOn || [null, null]
  );
  const [branches, setBranches] = useState(defaultValue?.branchId || []);

  const handleConfirm = () => {
    onConfirm({
      scheduledOn: period?.[0] && period?.[1] ? period : null,
      branchId: branches?.length > 0 ? branches : null,
    });
    onClose();
  };

  return (
    <ColumnFlexBox gap="16px" minWidth="300px">
      <DateRangeField
        id="campaigns-period-range"
        label="PERIOD"
        value={period}
        onChange={setPeriod}
        disableMinDate
      />
      <MultipleChipSelect
        label={intl.messages.BRANCHES}
        values={branches}
        onChange={(value) => setBranches(Array.isArray(value) ? value : [])}
        options={(userBranches || []).map(({ id, branchDescription }) => ({
          value: id,
          label: branchDescription,
        }))}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          position: 'sticky',
          bottom: 0,
          pt: '16px',
        }}
      >
        <Button id="confirm-filters-btn" size="large" onClick={handleConfirm}>
          {intl.messages.CONFIRM}
        </Button>
      </Box>
    </ColumnFlexBox>
  );
};

export default CampaignsFilters;
